import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { FavoritesProvider } from "./context/FavoritesContext";
import HomePage from "./pages/HomePage";
import StatePage from "./pages/StatePage";
import FavoritesPage from "./pages/FavoritesPage";
import Navbar from "./components/Navbar";
import "./App.css";

const App = () => {
    return (
        <FavoritesProvider>
            <Router>
                <Navbar />
                <div className="container-fluid">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route
                            path="/state/:stateName"
                            element={<StatePage />}
                        />
                        <Route path="/favorites" element={<FavoritesPage />} />
                    </Routes>
                </div>
            </Router>
        </FavoritesProvider>
    );
};

export default App;
